module.exports = __webpack_public_path__ + "img/p14.c0e34ef8.png";